import type { RuntimeLink } from '../../runtimeSettings'

export const isExternalHref = (href: string) => /^https?:\/\//i.test(href)

export const resolveLinkLabel = (link: RuntimeLink, locale: string) => {
  const exact = link.labels?.[locale]
  if (exact && exact.trim()) return exact.trim()

  const languagePrefix = locale.split('-')[0]?.toLowerCase() || ''
  const byLanguage = Object.entries(link.labels ?? {}).find(([entryLocale, entryLabel]) => {
    if (typeof entryLabel !== 'string' || !entryLabel.trim()) return false
    const entryPrefix = entryLocale.split('-')[0]?.toLowerCase() || ''
    return entryPrefix === languagePrefix
  })
  if (byLanguage?.[1] && byLanguage[1].trim()) return byLanguage[1].trim()

  return link.label
}
